import { useLocation, useNavigate } from 'react-router-dom';
import style from './menu.module.css';
import api from '../../../services/api';
import { useEffect, useState } from 'react';
import { IoArrowBackCircle } from 'react-icons/io5';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';


function Menu() {

    const local = useLocation();
    const navigate = useNavigate();
    const [material, setMaterial] = useState([]);
    const [linha, setLinha] = useState([]);
    const [categoria, setCategoria] = useState('');
    const [mate, setMate] = useState('');
    const [categ, setCateg] = useState(local.state.codcla);



    function Remclasses() {

        const element1 = document.querySelector('#lancamentos');
        element1.classList.remove(style.buttonsel);

        const element2 = document.querySelector('#cozinha');
        element2.classList.remove(style.buttonsel);

        const element3 = document.querySelector('#banheiro');
        element3.classList.remove(style.buttonsel);

        const element4 = document.querySelector('#lavanderia');
        element4.classList.remove(style.buttonsel);

        const element5 = document.querySelector('#cubas');
        element5.classList.remove(style.buttonsel);

        const element6 = document.querySelector('#nichos');
        element6.classList.remove(style.buttonsel);

        const element7 = document.querySelector('#espelhos');
        element7.classList.remove(style.buttonsel);

    }

    function Atualiza(wclasse, wcodpai, wtipfil) {
        Remclasses();
        const welement = document.querySelector('#' + wclasse);
        welement.classList.add(style.buttonsel);

        setCateg(wcodpai);
        GetMaterial(wcodpai, wtipfil);

        setLinha([]);
        setCategoria('');
        setMate('');
    }



    async function GetMaterial(wcodpai, wtipfil) {

        await api.get(`catalogo/material/?codpai=${wcodpai}&tipfil=${wtipfil}`)
            .then((resposta) => {
                setMaterial(resposta.data);
            }).catch((erro) => {

            })
    }

    async function GetLinhas(wcodcla) {
        await api.get(`catalogo/linha/?codcla=${wcodcla}`)
            .then((resposta) => {
                setLinha(resposta.data);
                setCategoria(resposta.data[0].categoria);
                setMate(resposta.data[0].material);


            }).catch((erro) => {

            })
    }


    function CreateMaterial() {
        if (local.state.codcla == 999)
            Atualiza("lancamentos", 999, local.state.tipfil);
        if (local.state.codcla == 3)
            Atualiza("cozinha", 3, local.state.tipfil);
        if (local.state.codcla == 6)
            Atualiza("banheiro", 6, local.state.tipfil);
        if (local.state.codcla == 206)
            Atualiza("lavanderia", 206, local.state.tipfil);
        if (local.state.codcla == 298)
            Atualiza("cubas", 298, local.state.tipfil);
        if (local.state.codcla == 299)
            Atualiza("nichos", 299, local.state.tipfil);
        if (local.state.codcla == 300)
            Atualiza("espelhos", 300, local.state.tipfil);

    }


    useEffect(() => {
        CreateMaterial();
    }, [])

    return (
        <div className={style.content}>

            <div className={style.menuhome}>
                <div className={style.menuhomecontent}>
                    <IoArrowBackCircle className={style.iconmenu} onClick={() => navigate('/catalogo')} />
                    <button id="lancamentos" onClick={(e) => Atualiza(e.target.id, 999, '')}>LANÇAMENTOS</button>
                    <button id="cozinha" onClick={(e) => Atualiza(e.target.id, 3, '')}>COZINHA</button>
                    <button id="banheiro" onClick={(e) => Atualiza(e.target.id, 6, '')}>BANHEIRO</button>
                    <button id="lavanderia" onClick={(e) => Atualiza(e.target.id, 206, '')}>LAVANDERIA</button>
                    <button id="cubas" onClick={(e) => Atualiza(e.target.id, 298, '')}>CUBAS</button>
                    <button id="nichos" onClick={(e) => Atualiza(e.target.id, 299, '')}>NICHOS</button>
                    <button id="espelhos" onClick={(e) => Atualiza(e.target.id, 300, '')}>ESPELHOS</button>

                </div>
            </div>




            <div className={style.materiais}>
                {material.map((mat) => {
                    return (
                        <div className={style.mat} key={mat.codcla}>
                            <div className={style.headermat}>
                                <a>{mat.descla}</a>
                            </div>

                            {/*<img src={mat.imgurl} className={style.imgmat} onClick={() => GetLinhas(mat.codcla)}></img>*/}

                            {/*<img onClick={() => navigate('/catalogo/produto', { state: { codcla: categ, codlin: mat.codcla } })} src={mat.imgurl} className={style.imgmat}></img>}*/}

                            {categ != 999 ?

                                < LazyLoadImage
                                    className={style.imgmat}
                                    alt={''}
                                    effect="blur"
                                    wrapperProps={{

                                        style: { transitionDelay: "1s" },
                                    }}
                                    src={mat.imgurl} onClick={() => GetLinhas(mat.codcla)} />

                                :

                                < LazyLoadImage
                                    alt={''}
                                    effect="blur"
                                    wrapperProps={{

                                        style: { transitionDelay: "1s" },
                                    }}
                                    src={mat.imgurl} className={style.imgmat} onClick={() => navigate('/catalogo/produto', { state: { codcla: categ, codlin: mat.codcla } })} />
                            }


                        </div>
                    )
                })}

            </div>


            <div className={style.headerlinha}>
                <span>{categoria} / {mate}</span>
            </div>
            <div className={style.linhas}>

                {linha.map((mat) => {
                    return (
                        <div className={style.mat} key={mat.codcla}>
                            <div className={style.headermat}>
                                <a>{mat.descla}</a>
                            </div>
                            < LazyLoadImage
                                alt={''}
                                effect="blur"
                                wrapperProps={{

                                    style: { transitionDelay: "1s" },
                                }}
                                onClick={() => navigate('/catalogo/produto', { state: { codcla: categ, codlin: mat.codcla } })} src={mat.imgurl} className={style.imgmat} />

                            {/*<img onClick={() => navigate('/catalogo/produto', { state: { codcla: categ, codlin: mat.codcla } })} src={mat.imgurl} className={style.imgmat}></img>*/}
                        </div>
                    )
                })}
            </div>

        </div>
    )
}


export default Menu;